import { PaymentChannelCodeEnum } from "@saleor/types/globalTypes";

export const getPaymentChannelCode = order => {
  const { payments } = order;
  const paymentMethodType =
    payments[0].paymentMethodType === "onlinebanking"
      ? "Online Banking"
      : payments[0].paymentMethodType === "ewallet"
      ? "E-Wallet"
      : payments[0].paymentMethodType;
  let channelCode = payments[0].channelCode;

  switch (paymentMethodType) {
    case "gcash":
      return "eWallet - GCASH";
    case "Online Banking":
    case "E-Wallet":
      if (Object.values(PaymentChannelCodeEnum).includes(channelCode)) {
        if (channelCode === PaymentChannelCodeEnum.PAYMAYA) {
          channelCode = "MAYA";
        }
        return `${paymentMethodType} - ${channelCode}`;
      } else {
        return paymentMethodType.toUpperCase();
      }
    default:
      return paymentMethodType.toUpperCase();
  }
};
